import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from './store';
import "./scss/carapace.css";
import "./scss/global.scss";
import vueScrollto from 'vue-scrollto'
import Notifications from 'vue-notification'
import htmlToPdf from '@/utils/htmlToPdf'
import { makeServer } from "./server"

if (process.env.NODE_ENV === "development") {
  //makeServer()
}

Vue.config.productionTip = false
Vue.use(vueScrollto);
Vue.use(Notifications)
Vue.use(htmlToPdf)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
